module.exports = __webpack_public_path__ + "img/files-icon.8650fe2c.svg";